module.exports = __webpack_public_path__ + "static/media/edit.f89535ce.svg";